// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-05-15T11:49:17Z                      #

// ##############################################################


export const BAREVNE = 'BAREVNE';

export const CERNOBILE = 'CERNOBILE';

/**
 * Seznam všech hodnot.
 */
export const values = [
    BAREVNE,
    CERNOBILE
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [BAREVNE]: {caption: ''},
    [CERNOBILE]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}